import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CollapseBlock } from '../index.jsx';
import { EduCourseDetail } from './EduCourseDetail.jsx';
import { useEduCourseBasicInformation } from '../../../hooks/useEduCourseBasicInformation.jsx';
import { useEduCourseExtendedInformation } from '../../../hooks/useEduCourseExtendedInformation.jsx';
import { useEduCourseLecturersInformation } from '../../../hooks/useEduCourseLecturerInformation.jsx';
import EduCourseDatesNestedTable from './EduCourseDatesNestedTable.jsx';

/**
 * Reusable component for displaying course detail information.
 * Used both in public pages and CMS.
 */
export const EduCourseDetailPage = ({
  courseDetail,
  showDatesSection = false,
  isAdmin = false,
  isAuthor = false,
  canUpdate = false,
  onRefetchCourses,
}) => {
  const { t } = useTranslation();

  const basicInformation = useEduCourseBasicInformation(courseDetail);
  const extendedInformation = useEduCourseExtendedInformation(courseDetail);
  const lecturersInformation = useEduCourseLecturersInformation(courseDetail);

  return (
    <>
      <CollapseBlock title={t('Základné informácie')} collapsible>
        <EduCourseDetail dataToRender={basicInformation} />
      </CollapseBlock>

      <CollapseBlock title={t('Lektori')} collapsible>
        <EduCourseDetail dataToRender={lecturersInformation} />
      </CollapseBlock>

      <CollapseBlock title={t('Rozšírené informácie')} collapsible>
        <EduCourseDetail dataToRender={extendedInformation} />
      </CollapseBlock>

      {showDatesSection && (
        <CollapseBlock title={t('Termíny')} collapsible>
          <EduCourseDatesNestedTable
            courseDetail={courseDetail}
            dates={courseDetail?.edu_course_dates ?? []}
            isAdmin={isAdmin}
            isAuthor={isAuthor}
            canUpdate={canUpdate}
            onRefetchCourses={onRefetchCourses}
            isPublic={!isAdmin && !isAuthor}
          />
        </CollapseBlock>
      )}
    </>
  );
};

EduCourseDetailPage.propTypes = {
  courseDetail: PropTypes.object,
  showDatesSection: PropTypes.bool,
  isAdmin: PropTypes.bool,
  isAuthor: PropTypes.bool,
  canUpdate: PropTypes.bool,
  onRefetchCourses: PropTypes.func,
};

export default EduCourseDetailPage;
